/**
 * Format health numbers: drop trailing ".0" (100.0 → 100) but keep real decimals (98.6).
 */
export function formatHealthNumberSmart(value: number): string {
  if (!Number.isFinite(value)) return "—";
  const rounded = Math.round(value * 10) / 10;
  if (Number.isInteger(rounded) || Math.abs(rounded - Math.round(rounded)) < 1e-6) {
    return String(Math.round(rounded));
  }
  return rounded.toFixed(1);
}

/** Stress / strain scores as whole-number percentages */
export function formatHealthPercentScore(value: number): string {
  if (!Number.isFinite(value)) return "—";
  const v = Math.round(Math.max(0, Math.min(100, value)));
  return `${v}%`;
}

/** Convert decimal hours (e.g. 7.92) to whole hours + minutes (7h 55m). */
export function decimalHoursToHm(hours: number): { h: number; m: number } {
  if (!Number.isFinite(hours) || hours <= 0) return { h: 0, m: 0 };
  const totalMinutes = Math.round(hours * 60);
  return { h: Math.floor(totalMinutes / 60), m: totalMinutes % 60 };
}

/** Human-readable sleep duration — prefer "7h 55m" over "7.9h". */
export function formatSleepDuration(hours: number): string {
  if (!Number.isFinite(hours) || hours <= 0) return "—";
  const { h, m } = decimalHoursToHm(hours);
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m} min`;
}
